import { checkPasswordStrength } from './password-strength.js';
import PendoButton from '../button/pendo-button.vue.js';
import PendoInput from '../input/pendo-input.vue.js';

function _empty() {}
function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}
function _invokeIgnored(body) {
  var result = body();
  if (result && result.then) {
    return result.then(_empty);
  }
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
var script = {
  name: 'PendoInputPassword',
  components: {
    PendoInput,
    PendoButton
  },
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    showPasswordStrength: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      passwordStrength: null,
      showPassword: false
    };
  },
  computed: {
    passwordStrengthLabel() {
      if (!this.value) {
        return;
      }
      return {
        0: 'Very weak',
        1: 'Weak',
        2: 'Average',
        3: 'Strong',
        4: 'Very strong'
      }[this.passwordStrength];
    }
  },
  watch: {
    value: _async(function () {
      const _this = this;
      return _invokeIgnored(function () {
        if (_this.showPasswordStrength) {
          return _awaitIgnored(_this.checkPasswordStrength());
        }
      });
    })
  },
  methods: {
    checkPasswordStrength: _async(function () {
      const _this2 = this;
      return _await(checkPasswordStrength(_this2.value), function (_ref) {
        let {
          score
        } = _ref;
        if (_this2.passwordStrength !== score) {
          _this2.passwordStrength = score;
          _this2.$emit('score', _this2.passwordStrength);
        }
      });
    }),
    toggleVisibility() {
      this.showPassword = !this.showPassword;
    },
    onFocus(event) {
      this.$emit('focus', event);
    },
    onInput(val) {
      this.$emit('input', val);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-input-password.vue2.js.map
